import {
	Component,
	OnInit
} from '@angular/core';
import {
	ActivatedRoute,
	ActivationEnd,
	Router
} from '@angular/router';
import {environment} from "@env/environment";
import {filter} from "rxjs";
import {AppConfigService} from "../../shared/services/config/app-config.service";

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	isMenuOpen: boolean = false;
	merchantId: any;
	appConfig = AppConfigService.config;
	logo = `${environment.s3Url}images/${environment.institutionCode}/logo.png`;

	constructor(private activatedRoute: ActivatedRoute, private router: Router) {

	}

	ngOnInit() {

		// Header is outside router outlet so we need to subscribe to router events to get merchantId
		this.router.events.pipe(
			filter(event => event instanceof ActivationEnd)
		).subscribe((event) => {
			const activationEndEvent = event as ActivationEnd;
			if (activationEndEvent.snapshot.params && activationEndEvent.snapshot.params['merchantId']) {
				this.merchantId = activationEndEvent.snapshot.params['merchantId'];
				if (this.merchantId && this.merchantId.length > 0) {
					this.logo = `${environment.s3Url}images/${environment.institutionCode}/${this.merchantId}_logo.png`;
				}
			}
		});

		if (!this.merchantId) {
			this.activatedRoute.queryParams.subscribe(params => {
				this.merchantId = params['merchantId'];
				if (this.merchantId && this.merchantId.length > 0) {
					this.logo = `${environment.s3Url}images/${environment.institutionCode}/${this.merchantId}_logo.png`;
				}
			});
		}
	}

	onLogoError() {
		this.logo = `${environment.s3Url}images/${environment.institutionCode}/logo.png`;
	}

	toggleMenu() {
		this.isMenuOpen = !this.isMenuOpen;
	}
}
